export const environment = {
    production: true,

        version: '1.5.0',
    releaseDate: '2026-10-13',
    //apiBaseUrl: 'http://62.182.209.144:8888/api',
    apiBaseUrl: '/api',
    ImagesUrl: 'https://zgranegrono.pl/images',
    FilesUrl: 'https://zgranegrono.pl/files',
    rootUrl: 'https://zgranegrono.pl/',

    FrontendConfigUrl: 'https://zgranegrono.pl/frontend-config',

    //production: true,
    //apiBaseUrl: '/api',
    //ImagesUrl: 'http://localhost:8081/images',
    //rootUrl: 'http://localhost:4200/',

     cardOrderPageIds: {
        DEFAULT: 'karta_dla_rodzica',
        CITIZEN: 'karta_dla_placacego_podatk',
        SENIOR: 'karta_dla_seniora',
        STUDENT: 'karta_dla_studenta'
    },

    firebaseConfig: {
        apiKey: "AIzaSyBbyPqgNpZ-xupydp21Flg6X347jHn81CA",
        authDomain: "zgrane-grono-56f13.firebaseapp.com",
        projectId: "zgrane-grono-56f13",
        storageBucket: "zgrane-grono-56f13.firebasestorage.app",
        messagingSenderId: "878120633197",
        appId: "1:878120633197:web:14d290fdf4e0b3f4645064",
        measurementId: "G-9Q4GF2ZVG6"
    },
    
    // Firebase Cloud Messaging VAPID key
    // Get this from: Firebase Console > Project Settings > Cloud Messaging > Web Push certificates
    firebaseVapidKey: 'BPH9dQD9xbxtIPn0hTPBfraesYvtoq6tJ1KoScjSAlMwbWVUmVN2u9qzG_QKyqAipduySjaQX2MJDzMUiW-LeN4'
};
